var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyanmar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7561 26.9564C39.5601 24.7899 40.0001 22.4464 40.0001 19.9999C40.0001 17.5535 39.5601 15.21 38.7561 13.0435L20.0001 11.3043L1.24405 13.0435C0.440139 15.21 6.10352e-05 17.5535 6.10352e-05 19.9999C6.10352e-05 22.4464 0.440139 24.7899 1.24405 26.9564L20.0001 28.6956L38.7561 26.9564Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7562 13.0435C35.9304 5.42744 28.5995 -6.10352e-05 20.0002 -6.10352e-05C11.4009 -6.10352e-05 4.07006 5.42744 1.2442 13.0435H38.7562Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 39.9999C28.5995 39.9999 35.9304 34.5724 38.7562 26.9564H1.2442C4.07006 34.5724 11.4009 39.9999 20.0002 39.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7148 16.9207H23.2377L20 6.95642L16.7624 16.9207H6.28528L14.7614 23.079L11.5238 33.0435L20 26.9564L28.4763 33.0434L25.2387 23.0789L33.7148 16.9207Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyanmar);
export default __webpack_public_path__ + "static/media/myanmar.158e6bb6682a78b48b29f56a0a8e90ef.svg";
export { ForwardRef as ReactComponent };